import { render, staticRenderFns } from "./SecurityRulesUpdateComponent.vue?vue&type=template&id=36fad7c2&"
import script from "./SecurityRulesUpdateComponent.vue?vue&type=script&lang=js&"
export * from "./SecurityRulesUpdateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports